import axios from "axios"
import { API_PREFIX } from "@/services/api/v1/const"

export default class ReportService {
  getOrdersAll(params) {
    return axios.post(`${API_PREFIX}/report/orders_all`, params)
  }
}
